import { create } from "zustand"
import { devtools } from "zustand/middleware"

import type * as StoreTypes from "@src/types/store"

import * as Slices from "@store/slices"

type StoreState = StoreTypes.StoreState

export const useLegacyStore = create<StoreState>()(
  devtools((set, get, ...args) => ({
    ...Slices.createInteractionsSlice(set, get, ...args),
    ...Slices.createQuestionsSlice(set, get, ...args),
    ...Slices.createLegacyProfilesSlice(set, get, ...args),
    ...Slices.createMediaSlice(set, get, ...args),
    ...Slices.createUsersSlice(set, get, ...args),
    ...Slices.createConversationSlice(set, get, ...args),
    ...Slices.createMessagesSlice(set, get, ...args),
    ...Slices.createChatMessagesSlice(set, get, ...args),
    ...Slices.createShareSlice(set, get, ...args),
  })),
)
